<template>
  <div class="basic_wrap">
    <div class="love-card">
      <div
        class="love-title"
        @click="$router.push('/buy/1')"
      >
        {{ $t("item.loveTitle") }}
      </div>
      <div class="cert-list">
        <div class="cert-item">
          <img
            class="cert-icon car-icon"
            :src="certImages.security"
            alt=""
          >
          <div class="cert-name">
            {{ $t("item.securityCertification") }}
          </div>
        </div>
        <div class="cert-item">
          <img
            class="cert-icon"
            :src="certImages.realName"
            alt=""
          >
          <div class="cert-name">
            {{ $t("item.realNameCertification") }}
          </div>
        </div>
        <div class="cert-item">
          <img
            class="cert-icon"
            :src="certImages.confidentiality"
            alt=""
          >
          <div class="cert-name">
            {{ $t("item.confidentialityCertification") }}
          </div>
        </div>
      </div>
      <div class="game-tabs">
        <button
          v-for="item in games"
          :key="item.value"
          type="button"
          class="game-tab"
          :class="{ active: activeGame === item.value }"
          @click="selectGame(item.value)"
        >
          {{ $t(item.label) }}
        </button>
      </div>
    </div>
    <div
      class="matching-box"
      @click="$router.push('/buy/1')"
    >
      {{ $t("item.onlineMatching") }}
    </div>
    <button
      type="button"
      class="upgrade-btn"
      @click="$router.push('/buy/1')"
    >
      {{ $t("item.upgradeData") }}
    </button>
  </div>
</template>
<script>
export default {
  name: "Item",
  data() {
    return {
		islogin: false,
		activeGame: "vote",
		games: [
			{value: "vote", label: "item.voteGame"},
			{value: "game2", label: "item.game2"},
			{value: "game3", label: "item.game3"},
			{value: "game4", label: "item.game4"}
		],
		certImages: {
			security: require("../images/ban3/qc.png"),
			realName: require("../images/ban3/jd.png"),
			confidentiality: require("../images/ban3/rz.png")
		}
    };
  },
  created() {
    this.$parent.footer("item", true);
  },
  mounted() {
  	this.islogin = localStorage.getItem('token')!=null;
  	if(!this.islogin){
  		this.$router.push("/login");
  	}
  },
  methods: {
    selectGame(value) {
      this.activeGame = value;
    },
    upgradeData() {

    }
  }
};
</script>

<style lang="less" scoped>
.basic_wrap {
  position: relative;
  overflow: hidden;
  padding: 180px 23px 70px;
  color: #142746;
  font-family: Arial, Helvetica, sans-serif;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f9d5e6 url(../images/ban3/game1.png) no-repeat top/100% 100%;
}

.love-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 532px;
  min-height: 252px;
  margin: 0 auto;
  padding: 66px 24px 22px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.74);
  box-sizing: border-box;
}

.love-title {
  position: absolute;
  top: 22px;
  left: 50%;
  min-width: 228px;
  height: 38px;
  padding: 0 18px;
  border-radius: 22px;
  box-sizing: border-box;
  transform: translateX(-50%);
  background: #f5329e;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 38px;
  text-align: center;
  white-space: nowrap;
}

.cert-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: end;
  gap: 20px;
  margin-top: 20px;
}

.cert-item {
  min-width: 0;
  text-align: center;
}

.cert-icon {
  display: block;
  width: 58px;
  height: 58px;
  margin: 0 auto 8px;
  object-fit: contain;
}

.car-icon {
  width: 82px;
}

.cert-name {
  min-height: 38px;
  font-size: 13px;
  font-weight: 400;
  line-height: 19px;
  text-align: center;
  white-space: pre-line;
  word-break: keep-all;
  overflow-wrap: normal;
}

.game-tabs {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  align-items: center;
  gap: 8px;
  margin-top: 24px;
}

.game-tab {
 min-width: 0;
 height: 25px;
 padding: 0 8px;
 border: 0;
 border-radius: 22px;
 font-size: 12px;
 line-height: 25px;
 text-align: center;
 white-space: nowrap;
}

.game-tab.active {
  background: #f5329e;
  color: #fff;
  font-weight: 700;
}

.matching-box {
  position: relative;
  z-index: 1;
  width: calc(100% - 54px);
  max-width: 478px;
  height: 54px;
  margin: 24px auto 36px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.74);
  color: #172b48;
  font-size: 18px;
  line-height: 54px;
  text-align: center;
}

.upgrade-btn {
  position: relative;
  z-index: 1;
  display: block;
  width: auto;
  max-width: calc(100% - 44px);
  min-height: 48px;
  margin: 0 auto;
  padding: 0 18px;
  border: 0;
  border-radius: 28px;
  background: #f5329e;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 48px;
  white-space: nowrap;
  text-align: center;
}

@media (max-width: 420px) {
  .basic_wrap {
    padding: 180px 16px 64px;
  }

  .love-card {
    min-height: 238px;
    padding: 62px 14px 20px;
  }

  .love-title {
    min-width: 205px;
    height: 34px;
    font-size: 14px;
    line-height: 34px;
  }

  .cert-list {
    gap: 10px;
  }

  .cert-icon {
    width: 50px;
    height: 50px;
  }

  .car-icon {
    width: 72px;
  }

  .cert-name {
    font-size: 14px;
    line-height: 17px;
  }

  .game-tabs {
    gap: 4px;
    margin-top: 22px;
  }

  .game-tab {
    height: 36px;
    padding: 0 6px;
    font-size: 12px;
    line-height: 36px;
  }

  .matching-box {
    width: calc(100% - 36px);
    height: 50px;
    margin: 22px auto 34px;
    font-size: 16px;
    line-height: 50px;
  }

  .upgrade-btn {
    min-height: 44px;
    font-size: 16px;
    line-height: 44px;
  }
}

/* This page keeps its own visual system; it is intentionally not shared globally. */
.basic_wrap {
  min-height: 100vh;
  height: auto;
  overflow: auto;
  padding: 142px 18px calc(86px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  color: #f5dfbd;
  background:
    linear-gradient(180deg, rgba(11, 4, 3, .16) 0%, rgba(14, 5, 4, .48) 44%, #120807 91%),
    linear-gradient(90deg, rgba(11, 4, 3, .52) 0%, rgba(11, 4, 3, .17) 52%, rgba(11, 4, 3, .36) 100%),
    url('../images/item/coffee-date-bg.jpg') 69% top / auto 100% no-repeat,
    #120807;
}

.love-card {
  max-width: 520px;
  min-height: 258px;
  padding: 68px 18px 20px;
  border: 1px solid rgba(230, 182, 105, .55);
  border-radius: 18px;
  background: linear-gradient(145deg, rgba(49, 25, 18, .86), rgba(22, 11, 9, .9));
  box-shadow: 0 16px 36px rgba(0, 0, 0, .42), inset 0 1px rgba(255, 231, 185, .12);
  backdrop-filter: blur(5px);
}

.love-title {
  top: -21px;
  min-width: 232px;
  height: 42px;
  border: 1px solid rgba(246, 210, 139, .72);
  border-radius: 24px;
  background: linear-gradient(105deg, #6e0d0c, #9f2d18 60%, #74120e);
  color: #ffe5ae;
  line-height: 40px;
  box-shadow: 0 7px 18px rgba(54, 6, 4, .42);
}

.cert-list { gap: 8px; margin-top: 15px; }
.cert-item + .cert-item { border-left: 1px solid rgba(230, 182, 105, .2); }
.cert-icon { width: 54px; height: 54px; margin-bottom: 10px; }
.car-icon { width: 72px; }
.cert-name { color: #d9bea0; font-size: 13px; line-height: 18px; }
.game-tabs { gap: 7px; margin-top: 19px; }
.game-tab {
  height: 34px;
  border: 1px solid rgba(185, 135, 59, .32);
  border-radius: 8px;
  background: rgba(255, 255, 255, .03);
  color: #c9ab86;
  line-height: 32px;
}
.game-tab.active {
  border-color: rgba(246, 210, 139, .62);
  background: linear-gradient(135deg, #6e0d0c, #9e3019);
  color: #ffe4ad;
}

.matching-box {
  width: 100%;
  max-width: 520px;
  height: 58px;
  margin: 25px auto 18px;
  border: 1px solid rgba(230, 182, 105, .46);
  border-radius: 15px;
  background: linear-gradient(105deg, rgba(45, 20, 14, .88), rgba(23, 11, 9, .9));
  box-shadow: 0 12px 26px rgba(0, 0, 0, .32), inset 0 1px rgba(255, 235, 190, .07);
  color: #f1ca80;
  font-size: 17px;
  line-height: 56px;
}

.upgrade-btn {
  width: 100%;
  max-width: 520px;
  min-height: 50px;
  border: 1px solid rgba(246, 210, 139, .7);
  border-radius: 13px;
  background: linear-gradient(105deg, #720b0c, #ad341a);
  box-shadow: 0 10px 22px rgba(76, 10, 7, .28);
  color: #ffe6b1;
  line-height: 48px;
}

@media (max-width: 420px) {
  .basic_wrap { padding: 132px 15px calc(82px + env(safe-area-inset-bottom)); background-position: center, center, 69% top, center; }
  .love-card { min-height: 244px; padding: 65px 11px 18px; }
  .love-title { height: 40px; line-height: 38px; }
  .cert-icon { width: 48px; height: 48px; }
  .car-icon { width: 64px; }
  .cert-name { font-size: 12px; }
  .game-tab { height: 32px; line-height: 30px; }
  .matching-box { width: 100%; height: 54px; margin: 22px auto 18px; line-height: 52px; }
  .upgrade-btn { min-height: 48px; line-height: 46px; }
}

/* Premium matchmaking chooser aligned with the refreshed main/home pages. */
.basic_wrap { color: #533126; background-image: linear-gradient(90deg, rgba(255, 250, 240, .99) 0%, rgba(255, 248, 235, .94) 49%, rgba(255, 248, 235, .32) 100%), linear-gradient(180deg, rgba(255, 255, 255, .2) 0%, rgba(255, 242, 218, .62) 100%), url('../images/fine-dining-hero.jpg'); background-repeat: no-repeat; background-position: center, center, 78% 46%; background-size: 100% 100%, 100% 100%, auto 178%; background-attachment: scroll; }.love-card { border-color: rgba(190, 139, 52, .48); background: rgba(255, 253, 248, .95); box-shadow: 0 13px 28px rgba(125, 82, 35, .1); }.love-title { border-color: rgba(166, 35, 61, .42); background: linear-gradient(105deg, #a6233d, #ca5a5b); color: #fff8e8; box-shadow: 0 7px 18px rgba(126, 28, 47, .18); }.cert-item + .cert-item { border-left-color: rgba(190, 139, 52, .24); }.cert-name { color: #63352c; }.game-tab { border-color: rgba(190, 139, 52, .4); background: #fff8e8; color: #815c45; }.game-tab.active { border-color: rgba(166, 35, 61, .45); background: #fff0ed; color: #a6233d; }.matching-box { border-color: rgba(190, 139, 52, .46); background: #fffdf8; box-shadow: 0 10px 22px rgba(125, 82, 35, .08); color: #873126; }.upgrade-btn { border-color: rgba(166, 35, 61, .42); background: linear-gradient(105deg, #a6233d, #ca5a5b); box-shadow: 0 9px 20px rgba(126, 28, 47, .2); color: #fff8e8; }
</style>
